module.exports = __webpack_public_path__ + "img/mobile_screens.fd1f6895.png";